import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { BehaviorSubject, Observable, catchError, map, of, skip, startWith, switchMap, take } from 'rxjs';
import { LgvPropertyService } from '../../../core/services/lgv-property.service';
import { NotificationService } from '../../../core/core.module';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';
import { getProperty, setProperty } from 'dot-prop';

@Component({
    selector: 'lgv-formly-address-autopopulate',
    templateUrl: './formly-address-autopopulate.component.html',
    styleUrls: ['./formly-address-autopopulate.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyAddressAutopopulateComponent extends FieldType<FieldTypeConfig> implements OnInit {
    addressAutocompleteForm: UntypedFormGroup;
    addressFieldModel = null;
    isAddressLoading$ = new BehaviorSubject(false);
    addressList: Observable<any[]>;
    @ViewChild('placesRef') placesRef: GooglePlaceDirective;
    @ViewChild('placesRef') placesRefHtml: HTMLElement;
    addressOptions = {
        fields: ['address_components'],
        types: ['address'],
        country: ['US']
    };
    addressControl = new FormControl();

    constructor(private lgvPropertyService: LgvPropertyService,
        private notifService: NotificationService,
        private loanFormUtilService: LgvFormUtilityService
    ) {
        super();
    }

    ngOnInit() {
        let currentStreet;

        var pathBase = this.getPathBase();

        var formService = this.loanFormUtilService?.dataModel$?.value;

        if (`${pathBase}.address.street`){
            getProperty(formService, `${pathBase}.address.street`)
        }
        currentStreet = getProperty(formService, `${pathBase}.street`)
        this.model.street = currentStreet;

        // this.addressControl.setValue({street: currentStreet});

        this.addressFieldModel = currentStreet; 

        this.addressList = this.addressControl?.valueChanges.pipe(
            //tap(t => {console.log('Tap from value changes') }),
            take(0), // don't trigger for now with google auto complete
            startWith(''),
            skip(4),
            switchMap(address => {
                this.isAddressLoading$.next(true);
                if (typeof (address) !== 'string') {
                    return of({
                        result: {
                            suggestions: []
                        }
                    })
                    // do not perform a search if query length is invalid from batchdata standards
                } else if (address.length < 4 || address.length > 25) {
                    return of([]);
                } else {
                    const body = {
                        searchCriteria: {
                            query: address
                        },
                        options: {
                            skip: 0,
                            take: 5
                        }
                    };
                    return this.lgvPropertyService.searchBatchDataAddress(body).pipe(catchError(() => {
                        this.notifService.error('There was an error with the address search. Please try again.')
                        return of([]);
                    }));
                }
            }),
            map(response => {
                this.isAddressLoading$.next(false);
                return response?.result?.suggestions;
            })
        );
    }

    displayFn(addressObj: any): string {
        return addressObj?.name;
    }

    onModelChange(value: any) {
        if (typeof value === 'string') {
            this.handleManualInput(value);
        }
    }

    public handleAddressChange(address: Address) {

        const streetAddress = address.address_components.find(a => a.types.includes("street_number"))?.short_name + " " +
            address.address_components.find(a => a.types.includes("route"))?.short_name;
        const state = address.address_components.find(a => a.types.includes("administrative_area_level_1"))?.short_name;
        const zip = address.address_components.find(a => a.types.includes("postal_code"))?.short_name;
        const city = !address.address_components.find(a => a.types.includes("locality"))?.short_name ?
            address.address_components.find(a => a.types.includes("neighborhood"))?.short_name :
            address.address_components.find(a => a.types.includes("locality"))?.short_name;

        var pathBase = this.getPathBase();
        const dataModel = this.loanFormUtilService.dataModel$.value;
        
        try {
            setProperty(dataModel, pathBase + '.street', streetAddress);
            setProperty(dataModel, pathBase + '.city', city);
            setProperty(dataModel, pathBase + '.state', state);
            setProperty(dataModel, pathBase + '.zipCode', zip);
        } catch (error) {

        }
        try {
            setProperty(dataModel, pathBase + '.address.street', streetAddress);
            setProperty(dataModel, pathBase + '.address.city', city);
            setProperty(dataModel, pathBase + '.address.state', state);
            setProperty(dataModel, pathBase + '.address.zipCode', zip);
        } catch (error) {

        }

        this.addressFieldModel = streetAddress; 

        //reload model 
        this.loanFormUtilService.dataModel$.next(this.loanFormUtilService.dataModel$.value);
        this.loanFormUtilService.updateChangeMap(this.field.parent.fieldGroup);
    }

    public handleManualInput(street: string){
        const dataModel = this.loanFormUtilService.dataModel$.value;
        var pathBase = this.getPathBase();

        if (this.field.key.toString().indexOf('address.') == 0){
            setProperty(dataModel,pathBase + '.address.street',street);
        } else{
            setProperty(dataModel,pathBase + '.street',street);
        }

        this.addressFieldModel = street;

        //reload model 
        this.loanFormUtilService.dataModel$.next(this.loanFormUtilService.dataModel$.value);
    }

    private getPathBase(){
        var pathBase = this.props?.modelToUpdate;
        if (this.props?.isRepeater && 'index' in this?.field?.parent) {
            
            const index = this?.field?.parent['index'];
            pathBase = `${this.props?.modelToUpdate}[${index}]`;
        }
        return pathBase;
    }
}
